export default __webpack_public_path__ + "static/media/beach-ball.ae631c84.svg";